import { useEffect, useState } from 'react'
import {useForm, useFieldArray } from'react-hook-form'
import Button from '../../components/button'
import DropDownListselect from '../../components/dropdown'
import Modal from '../../components/modal'
import UploadFiled from "../../components/fileduploader";
import CertificationForm from './subskillform'
import Styles from "./style.module.scss";
import { Icon } from '@iconify/react';
import * as CONSTANTS from "../../utils/CONSTANTS";
import StarRating from '../../components/rating';
import Headline5 from "../../components/headings/Headline5";
import { FormInput } from "../../wrappers/formInput";
import InfoTooltip from "../../components/infoTooltip";
import FormHead from "../../components/headings/FromHead";
import { FormAreaInput } from "../../wrappers/formArea";
import {submitDetails} from './services';
import {  uploadApi,postAPI } from "../../api/api";
import mixpanelData from '../../utils/mixpanel';
import { REACT_APP_CANDIDATE_FRELLANCER } from '../../utils/common';
const { v4: uuidv4 } = require("uuid");

export type uploadFormFields = {

  supportingDocument: string;


};

export default function Test(props:any) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      subSkills:props.defaultValues.subSkills
    }
  });
      const { fields, append, remove } = useFieldArray({
          control,
          name:'subSkills'
      })
  const [subSkillsData, SetSubSkillsData] = useState<any>([]);
  const [errorSubSkillsData, setErrorSubSkillsData] = useState<any>([]);
  const [errorsubSkillsRatingData, setErrorSubSkillsRatingData] = useState<any>([]);
  const [showValidationMessage, setShowValidationMessage] = useState<any>(false);
  let skillerror= 'Field is Required';
  let Certificationerror = 'Field is Required';
  let skillValuename= '';
  let skillValueid= '';
  
  if( props.defaultValues && props.defaultValues.skills.name!=='')
  {
    skillerror='';
    skillValuename=props.defaultValues.skills.name;
    skillValueid=props.defaultValues.skills.id;
  }
  let CertificationValue= '';
  if(props.defaultValues && props.defaultValues.certificationType!=='')
  { 
    Certificationerror='';
    CertificationValue=props.defaultValues.certificationType;
  }
  let Percentageerror= 'Field is Required';
  let PercentageValue= '';
  if(props.defaultValues.percentile!=='')
  {
    Percentageerror='';
    PercentageValue=props.defaultValues.percentile;
  }
  let OverRatingerror= 'Field is Required';
  let OverRatingValue=''
  if(props.defaultValues.overallRating )
  {
    OverRatingerror='';
    OverRatingValue= props.defaultValues.overallRating;
  }

  let  fetchFullFileName=''
  if(props.defaultValues.fileName  )
  {
   
    fetchFullFileName= props.defaultValues.fileName ;
  }
  let fetchFileName=''
  if(props.defaultValues.fileName  )
  {
   
    fetchFileName= props.defaultValues.fileName;
    fetchFileName=fetchFileName.slice(36, fetchFileName.length)
  }
  const [errorSkill,SetErrorSkill]=useState(skillerror);
  const [errorCertification,SetErrorCertification]=useState(Certificationerror);
  const [errorPercentage,SetErrorPercentage]=useState(Percentageerror);
  const [errorOverRating,SetErrorOverRating]=useState(OverRatingerror);
  const [skills,SetSkills]=useState({name:skillValuename,id:skillValueid});
  const [certifications,SetCertifications]=useState(CertificationValue);
  const [note, SetNote]=useState<string>('');
  const [errorNote,SetErrorNote]=useState('');
  const [showNote,SetShowNote]=useState(false);
  const [percentage,SetPercentage]=useState(PercentageValue);
  const [overallRating,SetoverallRating]=useState(OverRatingValue);
  const [certificationData, setCertificationData] = useState<{name: string, id:number}>({name:'',id:0})  
  const [uploadFileName, setUploadFileName] = useState<string>(fetchFileName);  
  const [fullUploadFileName, setFullUploadFileName] = useState<string>(fetchFullFileName);

    const userloginId = localStorage.getItem("loginId");

   useEffect(() => {
     SetShowNote(true);
     if (props.defaultValues.notes) {
      SetNote(props.defaultValues.notes)
     }
    if (props.defaultValues.certificationType === 'Interview')
    {
      setCertificationData({ name: "Interview", id: 2 });

    }
    else if(props.defaultValues.certificationType === 'Test')
    {
    
     setCertificationData({ name: "Test", id: 1 });

    }
    else if(props.defaultValues.certificationType === 'Github Review')
    {
    
      setCertificationData({ name: "Github Review", id: 3 });

    }
    else if(props.defaultValues.certificationType === 'Others')
    {
    
      setCertificationData({ name: "Others", id: 4 });
      SetErrorNote(" ")
    }
    else
    {
      setCertificationData({name:'',id:0});
      SetShowNote(false);

    }
   
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])
   
  
   const uploadFile = (e: any) => {
    let fileExtension = e.target.files[0].name.split(".").pop();
    if (fileExtension === "pdf" || fileExtension === "doc" || fileExtension === "docx") {

      let file = e.target.files[0]
      let type = file.type

      let fileName = uuidv4() + e.target.files[0].name.replace(/ /g, "");

      let value = {
        "action":"putObject",
        "filename":fileName
      }

      postAPI( REACT_APP_CANDIDATE_FRELLANCER + '/getsignedurlforresume',value).then((data) => {
        let signedUrl = data.url;
        uploadApi(signedUrl, file, type).then((response: any) => {
          // setDocument(fileName)
          // setValue('supportingDocument', fileName.slice(36, fileName.length))
          setFullUploadFileName(fileName);
          setUploadFileName(fileName.slice(36, fileName.length))
        })
      })
   
    }
  };
  
  
  const onSubmit = (value: any) => {
      setShowValidationMessage(true);
   if(errorSubSkillsData.length === 0 && errorsubSkillsRatingData.length === 0 && errorCertification === '' &&errorPercentage === ''  && errorSkill === '' && errorOverRating ===''  && errorNote ==='' )
   {
      const subskills=subSkillsData.map(function(item:any) { 
        delete item.key; 
        return item; 
      });

      var assessement={ skills, "certificationId": props.defaultValues && props.defaultValues.certificationId ? props.defaultValues.certificationId : null,  "certificationType": certifications, "overallRating": overallRating, "percentile":percentage,"fileName":fullUploadFileName, "hackerEarthReportUrl": props.defaultValues.hackerEarthReportUrl && props.defaultValues.hackerEarthReportUrl ,   notes:note, "subSkills":subskills}
      var payload={
        // action: 'add',
        loginId : props.loginId,
        userLoginId: userloginId,
        profileMetadata:{"ellowScreeningCertifications":[assessement]}
        };  
        submitDetails(payload).then((resp) => {
          if( resp && resp.status === 1){
            mixpanelData('New TG - Certification details updated', {
              'Source': 'Recruiter adds/updates certifcations of a candidate from assesment',
              'distinct_id': localStorage.getItem('Email'),
              'Recruiter email': localStorage.getItem('Email'),
              'Candidate name': `${ resp && resp.data[0] && resp.data[0].profile_metadata && resp.data[0].profile_metadata.firstName} ${resp && resp.data[0] && resp.data[0].profile_metadata && resp.data[0].profile_metadata.lastName}`,
              'Candidate email': resp.data[0].profile_metadata.email,
              'Candidate loginid': props.loginId,
              'Certification skill': assessement.skills.name,
              'Certification type': certifications,
              'Overall rating': overallRating,
              'Subskills': subskills && subskills.length > 0 && subskills.map((item: any) => item.subSkillName),
              'Percentile': percentage
            })

            props.clickHandler();
          }
        })
      }
    }

  const onChangecertificate = (e: any) => {
      if(e.value.name === 'Others')
      {
        SetErrorNote('Field is Required');
        SetShowNote(true);
      }
      else
      {
        SetErrorNote('');
        SetShowNote(true);
      }
      SetCertifications(e.value.name)
      SetErrorCertification(''); 
    };
    
    const onChangeoverallRating=(e:any)=>{
      if(e.value !==  '')
      {
        SetoverallRating(e.value);
        SetErrorOverRating('')
        
      }
      else
      {
        SetoverallRating('');
        SetErrorOverRating('Field is Required')
      }
    }

    const onChangeskills=(e:any)=>{
      SetSkills({name:e.value.name,id:e.value.id})  
      SetErrorSkill('');
    }

    const onChangePercentage=(e:any)=>{
    
      if(e.target.value !== '')
      {
        SetPercentage(e.target.value);
        SetErrorPercentage('');
      }
      else
      {
        SetPercentage('');
        SetErrorPercentage('Field is Required');
      }
    }

    const onChangeNote=(e:any)=>{
    
      if(e.target.value !== '')
      {
        SetNote(e.target.value);
        SetErrorNote('');
      }
      else
      {
        SetNote('');
        SetErrorNote('Field is Required');
      }
    }


    return (
        <Modal title={" "} size="medium" onClose={props.onClose}>
           <Headline5>Give Ratings</Headline5>
      <form>
      <div className="one-third-form-wrap small">
        <div className="form-group">
          <label className="lablel">Skills*</label>
          <DropDownListselect
              name="skills"
              data={props.skillsList}
              dataItemKey="id"
              textField="name"
              defaultValue={props.defaultValues.skills}
              // register={register}
              onChange={(e: any) => onChangeskills(e)}    
            />
            <div className={Styles.ratingError}> {showValidationMessage?errorSkill:''}</div>
        </div>
        <div className="form-group">
          <label className="lablel">Certifications Via*</label>
          <DropDownListselect
            name="certificationType"
            data={CONSTANTS.certifications}
            dataItemKey="id"
            textField="name"
            defaultValue={certificationData}
            onChange={(e: any) => onChangecertificate(e)}
          />
          <div className={Styles.ratingError}>{showValidationMessage?errorCertification:''}</div>
        </div>
        <div className="form-group">
          <FormInput
              name="percentage"
              type="number"
              id="percentage"
              label="Percentage"
              placeholder="Percentage"
              defaultValue={props.defaultValues.percentile}
             onChange={(e: any) => onChangePercentage(e)}
            />
           <div className={Styles.ratingError}>{showValidationMessage?errorPercentage:''}</div> 
        </div>
      </div>
      <div className="form-group">
                <label className="lablel">Upload Document</label>
                <div className="uploadWrap">
                  <FormInput<uploadFormFields>
                    id="supportingDocument"
                    type="text"
                    name="supportingDocument"               
                    disabled={true}
                    defaultValue={uploadFileName}
                    value={uploadFileName}
                  />
                  <UploadFiled uploadFile={uploadFile} />
                </div>
              </div>
      <div className="form-group">
    {showNote?
        <FormAreaInput
                  id="title"
                  type="text"
                  name="title"
                  label={errorNote === '' ? 'Note' : 'Note*'}
                  onChange={(e:any) => onChangeNote(e)}
                  defaultValue={note}
                  value={note}
                />
                :''}
{showNote?
  <div className={Styles.ratingError}>{showValidationMessage?errorNote:''}</div>:''}
    </div>
      <div className={Styles.ratingWrapper}>
        <StarRating label={'Overall Ratings'}   onChange={(e: any) => onChangeoverallRating(e)} defaultValue={props.defaultValues.overallRating}/>
        <InfoTooltip>
          1 <Icon icon="el:star" /> = 0-29 percentile
          <br/>
          2 <Icon icon="el:star" /> = 30-39 percentile
          <br/>
          3 <Icon icon="el:star" /> = 40-59 percentile
          <br/>
          4 <Icon icon="el:star" /> = 60-79 percentile
          <br/>
          5 <Icon icon="el:star" /> = 80+ percentile
        </InfoTooltip>
        <div className={Styles.ratingError}>{showValidationMessage?errorOverRating:''}</div> 
      </div>
      <div className={Styles.subHead}>
        <FormHead>Subskills</FormHead>
        <button className="btn btn-primary" onClick={(e: any) => {e.preventDefault(); append({})}}><Icon icon="fluent:add-12-regular" /> Add Subskills</button>
      </div>
      <div className="half-form-wrap">
        <div className="form-group mb-0">
          <label className="lablel">Subskills</label>
        </div>
        <div className="form-group mb-0">
          <label className="lablel">Rating</label>
        </div>
      </div>
           {fields.map((item , index) => {
                return (
                  
                        <CertificationForm 
                          showValidationMessage={showValidationMessage}
                          keyidd={uuidv4()} 
                          errorSubSkillsData={errorSubSkillsData} 
                          errorsubSkillsRatingData={errorsubSkillsRatingData} 
                          setErrorSubSkillsData={setErrorSubSkillsData}  
                          setErrorSubSkillsRatingData={setErrorSubSkillsRatingData}  
                          loginId={props.loginId} 
                          subSkillsData={subSkillsData} 
                          SetSubSkillsData={SetSubSkillsData} 
                          key={item.id}  
                          defaultValues={props.defaultValues.subSkills} 
                          removeId={index} 
                          remove={remove}  
                          index={index} 
                        />
                      
                    
               )
            })}
            <div>
               <div className="popupAction">
                 <Button variant="secondary" onClick={props.onClose}>
                 Close
                 </Button>
                 <Button variant="primary" onClick={handleSubmit(onSubmit)}>
                 Save
                </Button>
               </div>
            </div>
            </form>
            </Modal>
    )
}